import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
export function Comparison() {
  return <section className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-18">
      <div className="max-w-6xl mx-auto" data-id="element-19">
        <div className="text-center mb-8 sm:mb-12 md:mb-16" data-id="element-20">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-21">
            Deja el ruido, quédate con el cierre
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-2 gap-3 sm:gap-6 md:gap-8" data-id="element-22">
          <div className="bg-gray-50 rounded-xl sm:rounded-2xl p-3 sm:p-6 md:p-8 border border-gray-200" data-id="element-23">
            <div className="flex items-center justify-between mb-3 sm:mb-6" data-id="element-24">
              <h3 className="text-sm sm:text-xl md:text-2xl font-bold text-gray-900" data-id="element-25">
                WhatsApp
              </h3>
              <XIcon className="w-5 h-5 sm:w-7 sm:h-7 md:w-8 md:h-8 text-red-500 flex-shrink-0" data-id="element-26" />
            </div>
            <ul className="space-y-2 sm:space-y-4" data-id="element-27">
              <li className="flex items-start space-x-1.5 sm:space-x-3" data-id="element-28">
                <XIcon className="w-3.5 h-3.5 sm:w-5 sm:h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-29" />
                <span className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-30">
                  Desorden y pérdida de fichas
                </span>
              </li>
              <li className="flex items-start space-x-1.5 sm:space-x-3" data-id="element-31">
                <XIcon className="w-3.5 h-3.5 sm:w-5 sm:h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-32" />
                <span className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-33">
                  Sin trazabilidad ni métricas
                </span>
              </li>
              <li className="flex items-start space-x-1.5 sm:space-x-3" data-id="element-34">
                <XIcon className="w-3.5 h-3.5 sm:w-5 sm:h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-35" />
                <span className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-36">
                  Formatos distintos, malentendidos
                </span>
              </li>
              <li className="flex items-start space-x-1.5 sm:space-x-3" data-id="element-37">
                <XIcon className="w-3.5 h-3.5 sm:w-5 sm:h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-38" />
                <span className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-39">
                  Cero reputación/compliance
                </span>
              </li>
            </ul>
          </div>
          <div className="bg-indigo-50 rounded-xl sm:rounded-2xl p-3 sm:p-6 md:p-8 border-2 border-indigo-900 relative overflow-hidden" data-id="element-40">
            <div className="absolute inset-0 opacity-10" data-id="element-41">
              <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-900 rounded-full blur-3xl" data-id="element-42"></div>
            </div>
            <div className="flex items-center justify-between mb-3 sm:mb-6 relative" data-id="element-43">
              <h3 className="text-sm sm:text-xl md:text-2xl font-bold text-indigo-900" data-id="element-44">
                Canjee
              </h3>
              <CheckIcon className="w-5 h-5 sm:w-7 sm:h-7 md:w-8 md:h-8 text-green-600 flex-shrink-0" data-id="element-45" />
            </div>
            <ul className="space-y-2 sm:space-y-4 relative" data-id="element-46">
              <li className="flex items-start space-x-1.5 sm:space-x-3" data-id="element-47">
                <CheckIcon className="w-3.5 h-3.5 sm:w-5 sm:h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-48" />
                <span className="text-xs sm:text-sm md:text-base text-gray-900" data-id="element-49">
                  Ficha express + "Abierto a Canje" + % ofrecido
                </span>
              </li>
              <li className="flex items-start space-x-1.5 sm:space-x-3" data-id="element-50">
                <CheckIcon className="w-3.5 h-3.5 sm:w-5 sm:h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-51" />
                <span className="text-xs sm:text-sm md:text-base text-gray-900" data-id="element-52">
                  Trazabilidad completa (chat + bitácora)
                </span>
              </li>
              <li className="flex items-start space-x-1.5 sm:space-x-3" data-id="element-53">
                <CheckIcon className="w-3.5 h-3.5 sm:w-5 sm:h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-54" />
                <span className="text-xs sm:text-sm md:text-base text-gray-900" data-id="element-55">
                  Acuerdo estándar: roles, split, vigencia
                </span>
              </li>
              <li className="flex items-start space-x-1.5 sm:space-x-3" data-id="element-56">
                <CheckIcon className="w-3.5 h-3.5 sm:w-5 sm:h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-57" />
                <span className="text-xs sm:text-sm md:text-base text-gray-900" data-id="element-58">
                  Reputación real y cierres verificados
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}